// extracted by mini-css-extract-plugin
export default {"textarea":"src-modules-form-TextArea-style__textarea_4i4Hm","globalError":"src-modules-form-TextArea-style__globalError_21N+Z"};